const STORAGE_KEY = 'templateDrafts.v1';

const emptyForm = () => ({
  name: '',
  subject: '',
  content: '',
  type: 'initial',
});

export const createTemplateDraftId = () =>
  `draft-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export const readTemplateDrafts = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((d) => d && typeof d === 'object' && d.id);
  } catch (_) {
    return [];
  }
};

export const writeTemplateDrafts = (drafts) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.isArray(drafts) ? drafts : []));
  } catch (_) {
    // localStorage voll oder gesperrt
  }
};

export const upsertTemplateDraft = (draft) => {
  if (!draft?.id) return readTemplateDrafts();
  const list = readTemplateDrafts();
  const next = {
    id: String(draft.id),
    formData: {
      name: draft.formData?.name || '',
      subject: draft.formData?.subject || '',
      content: draft.formData?.content || '',
      type: draft.formData?.type || 'initial',
    },
    editorMode: draft.editorMode === 'design' ? 'design' : 'text',
    design: draft.design && typeof draft.design === 'object' ? draft.design : null,
    templateVars: Array.isArray(draft.templateVars) ? draft.templateVars : [],
    updatedAt: Date.now(),
  };
  const idx = list.findIndex((d) => d.id === next.id);
  if (idx >= 0) list[idx] = next;
  else list.unshift(next);
  writeTemplateDrafts(list);
  return list;
};

export const removeTemplateDraft = (id) => {
  const list = readTemplateDrafts().filter((d) => d.id !== String(id));
  writeTemplateDrafts(list);
  return list;
};

export const getTemplateDraft = (id) =>
  readTemplateDrafts().find((d) => d.id === String(id)) || null;

/** true, wenn der Entwurf sinnvollen Inhalt hat (sonst still verwerfen) */
export const draftHasContent = (draftLike) => {
  const form = draftLike?.formData || draftLike || emptyForm();
  if (String(form.name || '').trim()) return true;
  if (String(form.subject || '').trim()) return true;
  if (String(form.content || '').trim()) return true;
  if (draftLike?.design && typeof draftLike.design === 'object') {
    const blocks = draftLike.design.blocks;
    if (Array.isArray(blocks) && blocks.length > 0) return true;
  }
  return false;
};

export const snapshotTemplateEditor = ({
  formData,
  editorMode,
  design,
  existingAttachments = [],
  pendingAttachments = [],
  removedAttachmentIds = [],
}) =>
  JSON.stringify({
    formData: formData || emptyForm(),
    editorMode: editorMode || 'text',
    design: design || null,
    existingIds: (existingAttachments || []).map((a) => a.id).filter(Boolean),
    pending: (pendingAttachments || []).map((f) => ({
      name: f.name,
      size: f.size,
    })),
    removed: [...(removedAttachmentIds || [])].sort(),
  });
